import React, { useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';

import { CloseIcon } from 'components/Icons/CloseIcon';

import styles from './ForecastFeedbackPrompt.module.scss';

interface ForecastFeedbackPromptProps {
  onHidePrompt: () => void;
  openFeedbackForm: (isAccurate: boolean) => void;
}

const ForecastFeedbackPrompt: React.FC<ForecastFeedbackPromptProps> = ({
  onHidePrompt,
  openFeedbackForm,
}) => {
  const handleYesClick = useCallback(() => {
    openFeedbackForm(true);
  }, [openFeedbackForm]);

  return (
    <Box className={styles.container} data-testid="forecast-feedback-prompt">
      <Typography component="p" variant="footnote" className={styles.promptText}>
        Was our forecast accurate last time you surfed here?
      </Typography>
      <Box className={styles.buttonsContainer}>
        <Box className={styles.tooltipContainer}>
          <Button
            variant="secondary"
            className={styles.yes}
            data-testid="forecast-feedback-prompt-yes-button"
            onClick={handleYesClick}
            disableFocusRipple
            disableRipple
            disableTouchRipple
          >
            Yes
          </Button>
          <Button
            variant="secondary"
            data-testid="forecast-feedback-prompt-no-button"
            disableFocusRipple
            disableRipple
            disableTouchRipple
            onClick={() => openFeedbackForm(false)}
          >
            No
          </Button>
        </Box>
        <Button
          variant="secondary"
          className={styles.closeButton}
          disableFocusRipple
          disableRipple
          disableTouchRipple
          data-testid="prompt-close-button"
          onClick={onHidePrompt}
          aria-label="Close and dismiss forecast feedback prompt"
        >
          <CloseIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default ForecastFeedbackPrompt;
